import { render } from "./EventDetail.vue?vue&type=template&id=c730af22"
import script from "./EventDetail.vue?vue&type=script&lang=js"
export * from "./EventDetail.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\vue-basic\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__